import React, { useEffect, useRef, useState } from "react";
import "./WhyChooseUsSection.css";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;


const WhyChooseUsSection = () => {
  const { school_slug } = useParams();
  const [loading, setLoading] = useState(true);
  const formattedSchoolName = school_slug
    ?.split("-")
    .map((part, index) =>
      index === 0
        ? part.toUpperCase()          // TIGPS
        : part.toUpperCase()          // ALIPURDUAR / BOLPUR
    )
    .join(" - ");
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);
  const [flipped, setFlipped] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  /* =============================
     Intersection Observer
  ============================= */
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  /* =============================
     Resize Listener
  ============================= */
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleFlip = (index) => {
    setFlipped((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const [galleryImages, setGalleryImages] = useState([]);

  /* ---------------- FETCH DATA ---------------- */
  useEffect(() => {
    fetchContent();
  }, [school_slug]);

  const fetchContent = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${baseAPIUrl}admin/home_page/get_why_choose/${school_slug}`,
        { withCredentials: true }
      );

      if (res.data.status === 1 && res.data.data) {
        console.log(res.data);
        setGalleryImages(res.data.data || []);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  return (
    <section ref={sectionRef} className="why-tig-section">
      <div className="why-tig-container">
        <h2 className="why-tig-title mb-5">
          WHY CHOOSE {formattedSchoolName}
        </h2>

        <div className={`why-tig-grid ${inView ? "show" : ""}`}>
          {galleryImages.length > 0 ? (
            galleryImages.map((item, index) => (
              <div
                key={index}
                className="flip-card"
                onClick={() => isMobile && toggleFlip(index)}
                onMouseEnter={() => !isMobile && toggleFlip(index)}
                onMouseLeave={() => !isMobile && toggleFlip(index)}
              >
                <div className={`flip-card-inner ${flipped[index] ? "flipped" : ""}`}>

                  {/* FRONT */}
                  <div className="flip-card-front">
                    <img
                      src={
                        item.why_choose_image
                          ? `${baseAPIUrl}assets/images/why-choose-us/${item.why_choose_image}`
                          : "public/pictures/image.jpg"
                      }
                      alt={item.heading}
                    />
                    <div className="flip-card-overlay">
                      <h3>{item.heading}</h3>
                    </div>
                  </div>

                  {/* BACK */}
                  <div className="flip-card-back">
                    <h3>{item.heading}</h3>
                    <p>
                      {item.content}
                    </p>
                  </div>

                </div>
              </div>
            ))
          ) : (
            <p className="no-data-found" style={{ color: "#fff", textAlign: "center" }}>No data found</p>
          )}
        </div>
      </div>
    </section>

  );
};

export default WhyChooseUsSection;
